import { useMemo, useState } from "react";
import { useWorkflowList } from "../../hooks/useWorkflows";
import styles from "./AddWorkflowPanel.module.css";

interface Props {
  portalId: string;
  onAdd: (flowId: string) => void;
  placedFlowIds: Set<string>;
  onClose: () => void;
}

export default function AddWorkflowPanel({
  portalId,
  onAdd,
  placedFlowIds,
  onClose,
}: Props) {
  const { items, loading, error } = useWorkflowList(portalId);
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter((w) => w.name?.toLowerCase().includes(q));
  }, [items, query]);

  return (
    <div className={styles.panel}>
      <header className={styles.header}>
        <h2 className={styles.title}>Add workflow</h2>
        <button
          type="button"
          className={styles.close}
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
      </header>

      <input
        className={styles.search}
        placeholder="Search workflows…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />

      {loading && <div className={styles.empty}>Loading…</div>}
      {error && <div className={styles.error}>{error}</div>}
      {!loading && !error && filtered.length === 0 && (
        <div className={styles.empty}>No workflows match.</div>
      )}

      <ul className={styles.list}>
        {filtered.map((w) => {
          const placed = placedFlowIds.has(w.id);
          return (
            <li key={w.id}>
              <button
                type="button"
                className={styles.row}
                disabled={placed}
                onClick={() => onAdd(w.id)}
              >
                <span className={styles.rowName}>{w.name ?? w.id}</span>
                <span className={styles.rowMeta}>
                  {w.isEnabled ? "On" : "Off"}
                  {placed ? " · placed" : ""}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
